import { Navigation } from 'swiper';
import 'swiper/css/bundle';
import { Swiper, SwiperSlide } from 'swiper/react';

import { Box, IconButton, useColorMode } from '@chakra-ui/react';
import { IBookWithValues, INetProfit } from '../../types';
import { ArrowRightIcon } from '../icons';
import SignupCard from '../signup-card';

interface CarouselProps {
    booksWithValues: Partial<IBookWithValues>[];
    netProfits: INetProfit[];
}

function Carousel(props: CarouselProps) {
    var { booksWithValues, netProfits } = props;
    const { colorMode } = useColorMode();

    if (netProfits.length == 0){
        return (
            <Box w="full" position="relative">
                <SignupCard bookWithValues={{}} noBooksWithValues={false} noLinkedBooks={true}/>
            </Box>
        )
    }

    else if (booksWithValues.length == 0){
        return (
            <Box w="full" position="relative">
                <SignupCard bookWithValues={{}} noBooksWithValues={true} noLinkedBooks={false}/>
            </Box>
        )
    }

    return (
        <Box w="full" position="relative">
            <Swiper
                slidesPerView={2}
                spaceBetween={10}
                modules={[Navigation]}
                navigation={{
                    prevEl: '#carousel-prev',
                    nextEl: '#carousel-next',
                }}
                loop={false}
                centeredSlides={booksWithValues.length === 1}
                breakpoints={{
                    320: {
                        slidesPerView: 1,
                        spaceBetween: 10,
                    },
                    580: {
                        slidesPerView: 2,
                        spaceBetween: 10,
                    },
                }}
            >
                {booksWithValues.map((bookWithValues) => (
                    <SwiperSlide key={bookWithValues.id!}>
                        <SignupCard bookWithValues={bookWithValues} noBooksWithValues={false} noLinkedBooks={false}/>
                    </SwiperSlide>
                ))}
            </Swiper>
            {booksWithValues.length > 1 && (
                <>
                    <IconButton
                        id="carousel-prev"
                        position="absolute"
                        top="50%"
                        left="0"
                        transform={{
                            base: 'rotate(180deg) translateX(34%) translateY(50%)',
                            sm: 'rotate(180deg) translateX(50%) translateY(50%)',
                        }}
                        zIndex="2"
                        aria-label="carousel-prev"
                        w="32px"
                        h="32px"
                        maxW="32px"
                        color="skyBlue"
                        bg="navy"
                        borderRadius="8px"
                        border={colorMode == 'light' ? '' : '1px'}
                        borderColor={
                            colorMode == 'light' ? '' : 'alphaWhite005'
                        }
                        icon={<ArrowRightIcon />}
                        variant="icon"
                    />
                    <IconButton
                        id="carousel-next"
                        position="absolute"
                        top="50%"
                        left="100%"
                        transform={{
                            base: 'translateX(-66%) translateY(-50%)',
                            sm: 'translateX(-50%) translateY(-50%)',
                        }}
                        zIndex="2"
                        aria-label="carousel-next"
                        w="32px"
                        h="32px"
                        maxW="32px"
                        color="skyBlue"
                        bg="navy"
                        borderRadius="8px"
                        border={colorMode == 'light' ? '' : '1px'}
                        borderColor={
                            colorMode == 'light' ? '' : 'alphaWhite005'
                        }
                        icon={<ArrowRightIcon />}
                        variant="icon"
                    />
                </>
            )}
        </Box>
    );
}

export default Carousel;
